import {Dispatch} from 'redux'

import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  AnalyticsContext,
  Category,
  Entity,
  Page,
  Team
} from '@vio/core/src/analytics/types/Events'
import {SearchContext} from '@vio/core/src/analytics/types/Events'
import {Placement} from '@vio/core/src/deepLinking/types'

// Banner display event
export const trackBannerDisplayed = (
  pageName: Page,
  searchContext: SearchContext,
  placement: Placement,
  dispatch: Dispatch
) => {
  dispatch(
    trackEvent({
      category: Category.System,
      entity: Entity.AppInstallTouchPoint,
      action: Action.Displayed,
      team: Team.Retention,
      page: pageName,
      analyticsContext: {
        [AnalyticsContext.SearchContext]: searchContext
      },
      payload: {
        touchPointSource: placement
      }
    })
  )
}

// Banner click event
export const trackBannerClicked = (
  pageName: Page,
  searchContext: SearchContext,
  placement: Placement,
  dispatch: Dispatch
) => {
  dispatch(
    trackEvent({
      category: Category.User,
      entity: Entity.AppInstallTouchPoint,
      action: Action.Clicked,
      team: Team.Retention,
      page: pageName,
      analyticsContext: {
        [AnalyticsContext.SearchContext]: searchContext
      },
      payload: {
        touchPointSource: placement
      }
    })
  )
}
